<template>
  <div class="">
    <div >
      <div class="ivu-radio-group ivu-radio-group-button" type="button">
        <div :class="['ivu-radio-wrapper', {'ivu-radio-wrapper-checked':shortCut1==='all'}]" @click.stop="shortCut('all')">全部</div>
        <div :class="['ivu-radio-wrapper', {'ivu-radio-wrapper-checked':shortCut1==='dqr'}]" @click.stop="shortCut('dqr')">待确认({{dqrNum}})</div>
        <div :class="['ivu-radio-wrapper', {'ivu-radio-wrapper-checked':shortCut1==='djg'}]" @click.stop="shortCut('djg')">待交割({{dlrjgNum}})</div>
        <div :class="['ivu-radio-wrapper', {'ivu-radio-wrapper-checked':shortCut1==='dzf'}]" @click.stop="shortCut('dzf')">待支付({{dzfNum}})</div>
        <div :class="['ivu-radio-wrapper', {'ivu-radio-wrapper-checked':shortCut1==='bfzf'}]" @click.stop="shortCut('bfzf')">部分支付({{bfzfNum}})</div>
        <div :class="['ivu-radio-wrapper', {'ivu-radio-wrapper-checked':shortCut1==='ycq'}]" @click.stop="shortCut('ycq')">已超期({{ycqNum}})</div>
      </div>
    </div>
    <search-group title="" :multipleLines="true" :inline="true" :span="24" :btnOffset="18" :btnSpan="6" @search="findData" @clear="clearValue">
      <Row :gutter="16" class="mb16">
        <Col span="5">
          <Select placeholder="项目名称" v-model="searchData.projectFid" @on-change="changeProject">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
          <Select v-model="searchData.houseTypeFid" placeholder="房型名称">
            <Option value=''>{{ searchData.projectFid===''? '请先选择项目':(houseTypeList.length!==0 ?'请选择':'暂无数据')}}</Option>
            <Option  v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="合同状态" v-model="searchData.contractState">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in contractState" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="客户类型" v-model="searchData.customerType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in customerType" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="租约类型" v-model="searchData.leaseTime">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in leaseTime" :value="item.value" :key="'keyC'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="出租类型" v-model="searchData.stockRentType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in stockRentType" :value="item.value" :key="'keyD'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="物业交割状态" v-model="searchData.contractDelivery">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in contractDelivery" :value="item.value" :key="'keyE'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
      </Row>
      <Row :gutter="16" class="mb16">
        <Col span="5">
          <Select placeholder="审核状态" v-model="searchData.contractAuditStatus">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in contractAuditStatus" :value="item.value" :key="'keyF'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <Select placeholder="续约状态" v-model="searchData.isRenew">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in continueStatus" :value="item.value" :key="'keyX'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="签约方式" v-model="searchData.contractSource">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in contractSource" :value="item.value" :key="'keyG'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="签约类型" v-model="searchData.contractSignType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in contractSignType" :value="item.value" :key="'keyG'+index">{{item.text}}
            </Option>
          </Select>
        </Col>
        <Col span="3">
          <Select placeholder="支付状态" v-model="searchData.payState">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in payStateList" :value="item.value" :key="'keyK'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="6">
          <Input class="block" v-model="searchData.cusPhoneNumber"  @keyup.enter.native="findData" placeholder="签约ZO、签约客户、签约手机号、房间号、合同号"/>
        </Col>

      </Row>
      <Row :gutter="16">
        <Col span="6">
          <DatePicker class="block" type="daterange" split-panels placeholder="签约日范围" v-model="signDate" @on-change="getSignDate"></DatePicker>
        </Col>
        <Col span="6">
          <DatePicker class="block" type="daterange" split-panels placeholder="到期日范围" v-model="expireDate" @on-change="getExpireDate"></DatePicker>
        </Col>
        <Col span="6">
          <DatePicker class="block" type="daterange" split-panels placeholder="实际退租日范围"
                      v-model="releaseDate" @on-change="getReleaseDate"></DatePicker>
        </Col>
      </Row>

    </search-group>
  </div>
</template>

<script>
  import SearchGroup from 'components/SearchGroup/index';
  import {getStatusNum, selectCondition} from "../../../../api/contractList";
  import {getProjects} from "../../../../api/common";
  import {formatDateTime} from "../../../../utils/format";
  import { getHouseType } from "api/house"

  export default {
    // name: "SearchList",
    components: {
      SearchGroup
    },
    data() {
      return {
        shortCut1: 'all',
        redControl: [false, false, false, false, false],
        projectList: [],
        leaseTime: [],
        customerType: [],
        contractState: [],
        stockRentType: [],
        contractSource: [],
        contractDelivery: [],
        contractSignType: [],
        contractAuditStatus: [],
        continueStatus: [{text: '未续约', value: 0}, {text: '已续约', value: 1}],
        payStateList: [{text: '未支付', value: 0}, {text: '部分支付', value: 1}, {text: '已支付', value: 2}],
        signDate: [],
        expireDate: [],
        releaseDate: [],
        houseTypeList:[],
        searchData: {
          "contractAuditStatus": '',
          "contractDelivery": '',
          "contractSignType": '',
          "contractSource": "",
          "contractState": "",
          "cusPhoneNumber": "",
          "customerType": "",
          "expireEndDate": "",
          "expireStartDate": "",
          "leaseTime": "",
          "projectFid": "",
          "houseTypeFid": '',
          "releaseEndDate": "",
          "releaseStartDate": "",
          "signEndDate": "",
          "signStartDate": "",
          "stockRentType": '',
          "payState": "",
          isRenew: '',
          limit: 10,
          page: 1,
        },
        bfzfNum: 0,
        dlrjgNum: 0,
        dqrNum: 0,
        dzfNum: 0,
        ycqNum: 0,
      }
    },
    methods: {
      getSignDate(val){
        this.searchData.signStartDate = val[0]
        this.searchData.signEndDate = val[1]
      },
      getExpireDate(val){
        this.searchData.expireStartDate = val[0]
        this.searchData.expireEndDate = val[1]
      },
      getReleaseDate(val){
        this.searchData.releaseStartDate = val[0]
        this.searchData.releaseEndDate = val[1]

      },
      shortCut(value) {
        this.shortCut1=value
        switch (value) {
          case 'all':
            this.searchData = {
              "contractAuditStatus": '',
              "contractDelivery": '',
              "contractSignType": '',
              "contractSource": "",
              "contractState": "",
              "cusPhoneNumber": "",
              "customerType": "",
              "expireEndDate": "",
              "expireStartDate": "",
              "leaseTime": "",
              "projectFid": "",
              "houseTypeFid": '',
              "releaseEndDate": "",
              "releaseStartDate": "",
              "signEndDate": "",
              "signStartDate": "",
              "stockRentType": "",
              "payState": "",
              "isRenew": '',
              limit: 10,
              page: 1,
              // signDate: ['', ''],
              // expireDate: ['', ''],
              // releaseDate: ['', '']
            };
            break;
          case 'dqr':
            this.clearValue()
            this.searchData.contractState = 'dqr';
            break;
          case 'djg':
            this.clearValue()
            this.searchData.contractDelivery = 0;
            break;
          case "ycq":
            this.clearValue()
            this.searchData.contractState = 'ycq';
            break;
          case 'dzf':
            this.clearValue()
            this.searchData.payState = 0;
            break;
          case 'bfzf':
            this.clearValue()
            this.searchData.payState = 1;
            break;
        }
        this.$emit('findData', this.searchData)
      },

      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)
      },
      findData() {
        // this.searchData.signStartDate = this.format(this.searchData.signDate[0])
        // this.searchData.signEndDate = this.format(this.searchData.signDate[1])
        // this.searchData.expireStartDate = this.format(this.searchData.expireDate[0])
        // this.searchData.expireEndDate = this.format(this.searchData.expireDate[1])
        // this.searchData.releaseStartDate = this.format(this.searchData.releaseDate[0])
        // this.searchData.releaseEndDate = this.format(this.searchData.releaseDate[1])
        this.$emit('findData', this.searchData)
      },
      clearValue() {
        this.signDate= []
        this.expireDate = []
        this.releaseDate = []
        this.searchData = {
          "contractAuditStatus": '',
          "contractDelivery": '',
          "contractSignType": '',
          "contractSource": "",
          "contractState": "",
          "cusPhoneNumber": "",
          "customerType": "",
          "expireEndDate": "",
          "expireStartDate": "",
          "leaseTime": "",
          "projectFid": "",
          "houseTypeFid": '',
          "releaseEndDate": "",
          "releaseStartDate": "",
          "signEndDate": "",
          "signStartDate": "",
          "stockRentType": "",
          "payState": "",
          "isRenew": '',
          limit: 10,
          page: 1,

        }
      },
      changeProject(value) {
        if(value === '') {
          this.houseTypeList = []
        }else{
          getHouseType(value).then(res => {
            this.houseTypeList = res.data.houseTypeList
          })
        }
      },
    },
    activated(){
      if(this.$route.params.cusPhoneNumber){
        this.clearValue()
        this.searchData.cusPhoneNumber = this.$route.params.cusPhoneNumber
        this.$emit('findData', this.searchData)
      }

    },
    created() {
      // console.log(this.$route, "222222")
      if(this.$route.params.cusPhoneNumber){
        this.searchData.cusPhoneNumber = this.$route.params.cusPhoneNumber
      }

      getStatusNum().then(res => {
        if(!res.data){
          return
        }
        let data = res.data
        this.bfzfNum = data.bfzfNum
        this.dlrjgNum = data.dlrjgNum
        this.dqrNum = data.dqrNum
        this.dzfNum = data.dzfNum
        this.ycqNum = data.ycqNum
      }).catch(error => {
        let data = {
          "bfzfNum": 0,
          "dlrjgNum": 0,
          "dqrNum": 0,
          "dzfNum": 0,
          "ycqNum": 0
        }
        this.bfzfNum = data.bfzfNum
        this.dlrjgNum = data.dlrjgNum
        this.dqrNum = data.dqrNum
        this.dzfNum = data.dzfNum
        this.ycqNum = data.ycqNum
      })
      selectCondition().then(res => {
        if(!res.data){
          return
        }
        let data = res.data
        this.leaseTime = data.leaseTime
        this.customerType = data.customerType
        this.contractState = data.contractState
        this.stockRentType = data.stockRentType
        this.contractSource = data.contractSource
        this.contractDelivery = data.contractDelivery
        this.contractSignType = data.contractSignType
        this.contractAuditStatus = data.contractAuditStatus
      }).catch(error => {

      })
      getProjects().then(res => {
       res.data && ( this.projectList = res.data)
      }).catch(error => {
      })
    }
  }
</script>
<style scoped>
  .flex {
    display: block;

  }
  .search-wrapper{
    padding: 24px  0 !important;

  }

  .shortcut a {
    display: inline-block;
    padding: 10px 20px;
    font-weight: bold;
    color: #444444;
  }

  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

  .block {
    display: block;
  }

</style>
